var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InstitucionalPageTemplate',_vm._b({attrs:{"loading":_vm.loading}},'InstitucionalPageTemplate',_vm.item,false))}
var staticRenderFns = []

export { render, staticRenderFns }